import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import { Box, Drawer, useMediaQuery } from '@mui/material';

const drawerWidth = 240;

const Layout = ({ userName, isAuth, logout, theme, hasLimit }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const handleDrawerToggle = () => {
        setMobileOpen(prev => !prev);
    };
    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
            <Drawer
                variant={isMobile ? 'temporary' : 'permanent'}
                open={isMobile ? mobileOpen : true}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
            >
                <Sidebar hasLimit={hasLimit} onItemClick={() => isMobile && setMobileOpen(false)} />
            </Drawer>
            <Box
                sx={{
                    flexGrow: 1,
                    minHeight: '100vh', display: 'flex', flexDirection: 'column',
                    ml: isMobile ? 0 : `${drawerWidth}px`,
                }}
            >
                <Header
                    userName={userName} onMenuClick={handleDrawerToggle}
                />

                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        px: {
                            xs: 1.5,
                            sm: 3,
                        },
                        pb: 3,
                    }}
                >
                    <Outlet />
                </Box>
                <Box
                    component="footer"
                    sx={{
                        px: {
                            xs: 1.5,
                            sm: 3,
                        },
                        py: 3,
                    }}>
                    <Footer />
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;
